import { NODE_MENU_MARGIN } from '@constants/canvas/general';
import { ReactFlowId } from '@constants/entities/reports';

type ClampTopArgs = {
  desiredTop: number;
  menuHeight: number;
  paneTop: number;
  paneBottom: number;
  margin?: number;
};

export const clampTop = ({
  desiredTop,
  menuHeight,
  paneTop,
  paneBottom,
  margin = NODE_MENU_MARGIN,
}: ClampTopArgs): number => {
  const minTop = paneTop + margin;
  const maxTop = paneBottom - menuHeight - margin;

  if (maxTop <= minTop) return minTop;

  return Math.min(Math.max(desiredTop, minTop), maxTop);
};

export const clampMenuTopToPane = (
  desiredTop: number,
  menuEl: HTMLElement | null,
  margin = NODE_MENU_MARGIN,
): number => {
  const pane = document
    .querySelector(`#${ReactFlowId}`)
    ?.getBoundingClientRect();

  if (!menuEl || !pane) return desiredTop;

  return clampTop({
    desiredTop,
    menuHeight: menuEl.getBoundingClientRect().height,
    paneTop: pane.top,
    paneBottom: pane.bottom,
    margin,
  });
};
